<div class="container">
    <div class="loader">
        <div class="t-block stem"></div>
        <div class="t-block cross-left"></div>
        <div class="t-block cross-right"></div>
        <div class="checkmark-container">
            <div class="checkmark-stem"></div>
            <div class="checkmark-kick"></div>
        </div>
        <svg class="outline-svg">
            <rect class="outline-rect" x="1.5" y="1.5" width="97" height="107" rx="4"/>
        </svg>
    </div>
    <div class="text">TaskTrackerPro</div>
</div>
